import { AppParagraph } from 'components/atoms';

export const CountDisplay = ({ count }: { count: number }) => (
    <AppParagraph textAlign="center" textType="BodyMediumSemiBold">
        {count}
    </AppParagraph>
);
